import React, { useState } from 'react';

// Import images explicitly
import cardImage1 from '../img/envision/logos-to-add/lt-removebg-preview.png';
import cardImage2 from '../img/envision/logos-to-add/introsy-removebg-preview.png';
import cardImage3 from '../img/envision/logos-to-add/tata-removebg-preview.png';
import cardImage4 from '../img/envision/logos-to-add/Jaguar-company-removebg-preview.png';
import cardImage5 from '../img/envision/logos-to-add/daf-removebg-preview.png';
import cardImage6 from '../img/envision/logos-to-add/vdl-removebg-preview.png';
import cardImage7 from '../img/envision/logos-to-add/tyseekar-removebg-preview.png';
import cardImage8 from '../img/envision/logos-to-add/fft-removebg-preview.png';

// Define the Card component
const Card = ({ description, image }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const cardStyles = {
    card: {
      width: '300px',
      height: '290px',
      border: '1px solid #ccc',
      borderRadius: '12px',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      backgroundColor: isHovered ? '#0785a3' : '#fff',
      color: isHovered ? '#fff' : '#333', // Change text color for better contrast
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '20px',
      transition: 'background-color 0.3s ease, transform 0.3s ease, color 0.3s ease',
      cursor: 'pointer',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '150px', // Ensure this height is sufficient to cover the image area
      backgroundColor: isHovered ? '#0785a3' : '#fff', // Hover color for the image section
      borderRadius: '12px 12px 0 0', // Rounded corners on top
      transition: 'background-color 0.3s ease',
      overflow: 'hidden', // Ensure the image doesn't spill over the container
    },
    image: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
    description: {
      fontSize: '16px',
      lineHeight: '1.5',
      margin: '0',
    },
  };

  return (
    <div
      style={cardStyles.card}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={cardStyles.imageContainer}>
        <img src={image} alt="card" style={cardStyles.image} />
      </div>
      <p style={cardStyles.description}>{description}</p>
    </div>
  );
};

const Aboutwithparthers = () => {
  return (
    <div style={styles.container}>
      <Card
        description="A consulting partner, providing smart operations "
        image={cardImage1}
      />
      <Card
        description="System Integration partner for Asset Management."
        image={cardImage2}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage3}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage4}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage5}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage6}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage7}
      />
      <Card
        description="Modernizing and transforming enterprises' field ."
        image={cardImage8}
      />
    </div>
    
  );
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    padding: '20px',
    backgroundColor: '#fff',
  },
};

export default Aboutwithparthers;
